// navbar_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hamburger", "navLinks", "dropdownLink"]

  connect() {
    // Setup listeners
    this.dropdownLinkTargets.forEach(link => {
      link.addEventListener("click", this.toggleDropdown.bind(this))
    })
  }

  toggleMenu() {
    this.navLinksTarget.classList.toggle("active")
  }

  closeMenu() {
    this.navLinksTarget.classList.remove("active")
  }

  toggleDropdown(e) {
    if (window.innerWidth < 900) {
      e.preventDefault()
      e.currentTarget.parentElement.classList.toggle("active")
    }
  }
}
